import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'itemPositionClass', pure: true })
export class ItemPositionClassPipe implements PipeTransform {
  transform(
    index: number,
    current: number,
    total: number
  ): string {
    if (index === current) return 'active';
    if (index === (current - 1 + total) % total) return 'left';
    if (index === (current + 1) % total) return 'right';
    if (index === (current - 2 + total) % total) return 'offscreen-left';
    if (index === (current + 2) % total) return 'offscreen-right';
    return '';
  }
}
